import Lockable from "../../common/Lockable";
import Box from "@mui/material/Box";
import { getFileTypeMime } from "../../../utils";
import thumbMp3 from "../../../assets/img/thumb-mp3.png";
import thumbVideo from "../../../assets/img/thumb-video.jpg";
import thumbOther from "../../../assets/img/thumb-NFT.png";

const thumbLink = (image, cover, type) => {
	const content = getFileTypeMime(type);
	let link;
	if (content !== "image") {
		link = cover ? `${process.env.REACT_APP_API_DO_URL}/${image}` : thumbOther;
	} else {
		if (type !== "image/gif") {
			link = `${process.env.REACT_APP_API_DO_URL}/${image}`;
		} else link = thumbOther;
	}

	return link;
};
export const columns = [
	{
		name: "TokenID",
		width: "90px",
		selector: (row) => row.tokenID,
		cell: (row) => (
			<div
				className="d-flex justify-content-left align-items-center"
				onClick={() => row.onCellClick(row._id)}
			>
				<div className="d-flex flex-column px-0">
					<p className="text-truncate text-body m-0">
						<span className="fw-bolder">{row.tokenID || "None"}</span>
					</p>
				</div>
			</div>
		),
	},
	{
		name: "Image",
		width: "90px",
		selector: (row) => row.image,
		cell: (row) => (
			<div
				className="d-flex justify-content-left align-items-center"
				onClick={() => row.onCellClick(row._id)}
			>
				<div className="d-flex flex-column">
					<Box
						component="img"
						sx={{ maxWidth: "100%", maxHeight: "100%" }}
						className="text-truncate text-body m-0"
						alt="thumbnail"
						src={`${process.env.REACT_APP_API_DO_URL}/${row.thumbnail}`}
						onError={({ currentTarget }) => {
							currentTarget.onerror = null;
							currentTarget.src = thumbOther;
						}}
					/>
				</div>
			</div>
		),
	},
	{
		name: "Name",
		width: "150px",
		selector: (row) => row.name,
		cell: (row) => (
			<div className="text-truncate" onClick={() => row.onCellClick(row._id)}>
				{row.name}
				{/* <p className="text-body m-0"> */}
				{/* <span className="fw-bolder">{row.name}</span> */}
				{/* </p> */}
			</div>
		),
	},
	{
		name: "# of tokens",
		width: "110px",
		selector: (row) => row.amount,
		cell: (row) => (
			<div
				className="d-flex justify-content-left align-items-center"
				onClick={() => row.onCellClick(row._id)}
			>
				<p className="text-truncate text-body m-0">
					<span className="fw-bolder">
						{row.tokenStats.balanceOf}({row.amount})
					</span>
				</p>
			</div>
		),
	},
	{
		name: "Status",
		width: "120px",
		selector: (row) => row.tokenStats,
		cell: (row) => (
			<div
				className="d-flex justify-content-left align-items-center"
				onClick={() => row.onCellClick(row._id)}
			>
				<p className="text-truncate text-body mb-0">
					<span
						className="badge badge-glow"
						style={{
							display: "inline-block",
							padding: "4px 7px",
							borderRadius: "5px",
							color: "#fff",
							backgroundColor:
								row.tokenStats.type === "ERC721"
									? row.tokenStats.owned
										? "#7367f0" // Owned
										: row.tokenStats.burnt
										? "#ea5455" // Burnt
										: "#28c76f" //transferred
									: row.tokenStats.type === "ERC1155"
									? row.tokenStats.owned
										? "#7367f0"
										: "rgb(147 147 147)"
									: "grey",
						}}
					>
						{row.tokenStats.type === "ERC721"
							? row.tokenStats.owned
								? "Active" // Owned
								: row.tokenStats.burnt
								? "Burnt" // Burnt
								: "Transferred" //transferred
							: row.tokenStats.type !== "ERC1155"
							? "---"
							: row.tokenStats.owned
							? "Owned"
							: "Ended"}
					</span>
				</p>
			</div>
		),
	},
	{
		name: "Lockable",
		width: "120px",
		selector: (row) => row.link,
		cell: (row) => (
			<div className="d-flex justify-content-left align-items-center">
				{row.link ? (
					<Lockable link={row.link} />
				) : (
					<p className="text-truncate text-body word-wrap mb-0">Not Lockable</p>
				)}
			</div>
		),
	},
	{
		name: "Certify Labs Lockable",
		selector: (row) => row.unlockableLink,
		cell: (row) => (
			<div className="d-flex justify-content-left align-items-center">
				{row.unlockableLink ? (
					<Lockable link={row.link} boxetLink={row.unlockableLink} />
				) : (
					<p className="text-truncate text-body word-wrap mb-0">Not Lockable</p>
				)}
			</div>
		),
	},
	{
		name: "GAS",
		selector: (row) => row.gas,
		cell: (row) => (
			<div
				className="d-flex justify-content-left align-items-center"
				onClick={() => row.onCellClick(row._id)}
			>
				<p className="text-truncate text-body m-0">
					<span className="fw-bolder">{row.gas}</span>
				</p>
			</div>
		),
	},
];
